export const environment = {
    webMapId: 'e2a36ed185ad43c3a36779d5a557b42b',
    webMapUrl: "https://vigo.maps.arcgis.com/",
    otpUrl: "https://routingvigo-otp.nexusgeografics.com/v1/",
    otpRoutesUrl: "https://routingvigo-otp.nexusgeografics.com/otp/routers/default/plan",
};
